<template>


<div class="container-fluid">
    <div id="loading-screen" v-show="isLoading">
    <div class="fancy-loader">
      <span>LOADING</span>
      <svg xmlns="http://www.w3.org/2000/svg" class="lds-comets" width="250px" height="250px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="rotate(162.228 50 50)">
      <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" values="360 50 50;240 50 50;120 50 50;0 50 50" keyTimes="0;0.333;0.667;1" dur="1s" keySplines="0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1" calcMode="spline"/>
      <path fill="#41918E" d="M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"/>
      <path fill="#E0E0E0" d="M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"/>
      <path fill="#80CBC4" d="M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"/></g>
      </svg>
    </div>
 
  </div>
  <div class="row">
    <div class="col-xs-4 col-md-12">
                             <div data-intro='<b>Not Available on Help page</b><p>To play the tour guide, click on MSDAT platform and select the tour guide</p>'></div>
      <div v-tooltip.right="'Back to platform'" class="back-to-car-icon" @click="navigateToCentralAnalytics">
        <v-icon class="back-to-car-icon-v" style="color:white;">arrow_back</v-icon>
      </div>
    </div>
  </div>

  <div class="nanleContainer">
    <div class="row">
      <div class="col-xs-12 col-md-12" style="padding:15px;">
          <h1 id="top_of_page" class="about_title">Multi-Source Data Analytics and Triangulation Platform</h1>
        <h5 class="about_subtitle">This platform is developed and managed by the Department of Health, Planning and Research Statistics (DHPRS)</h5>
    </div> 
  </div>
  <div class="row" style="padding:10px;">
      <div class="col-xs-12 col-md-6">
        <p>
          <img src="static/img/About-Dashboard-image.png">
        </p>
      </div>
      <div class="cnick col-md-6">
        <aside>
            <h1>About Platform</h1>
            <p class="about_content">
              The essence of health data is to ensure that decision-makers have the means to make informed decisions and policies for healthcare.
              <a class="visible-xs-block" @click="aboutContent=!aboutContent">{{aboutContent ? 'Show Less':'Show More'}}</a>
            </p> 
              
            <div v-show="aboutContent">
              <p class="about_content">This Multi-Source Data Analytic and Triangulation resource developed by the Federal Ministry of Health (FMoH) Nigeria provides a single transparent view of key health indicators from multiple data sources. Recognizing that data quality, trends and interpretation depend on the data source and methodology, the platform offers comparisons of key metrics across three categories of data sources, namely; routine, surveys, and global estimates. </p>
              <p class="about_content">By transparently visualizing data and trends across multiple sources, we intend improving the debate and focus on data quality and its use, so as to reduce variations that exist between different sources over time and improve our overall understanding of key trends and progress within the health sector.</p>
              <p class="about_content">
              This resource has been developed and is being expanded in phases building on connections with existing FMOH agencies and partners. As this resource evolves, DHPRS hopes to contribute to improved performance management within the health sector. 
            </p>
            <p class="about_content">
              The first phase started with exploration analysis using some selected indicators at the federal and state level. Subsequent phases will gradually increase the number of indicators available for analysis, and then widen the coverage of health data analysis to LGA and facility level as well.
            </p>
            <p class="about_content">
              The DHPRS team welcomes feedback on this resource and invites stakeholders to upload relevant data using the submit data button on the platform.
            </p>
            </div>
          </aside>
      </div>
  </div>

  <div class="row" style="padding:10px;">
    <div class="col-md-12 cnick">
      <h1>Indicators</h1>
        <p class="about_content">The indicators available on the Multi-Source Data Analytics and Triangulation Platform have been categorized by their program areas and can be seen below. To see the indicators, click the drop down on each program area.</p>
    </div>
  </div>

  <div class="row" style="padding:15px;">
      <div v-for="(indicator,index,i) in indicators" :key="i" class="col-xs-12 col-md-3" style="padding-bottom:32px; padding-top:10px;">
      <!-- col-md-12--col-md-3 -->
      <div class="indicator-names-button" @click="indicator.show=!indicator.show">
        <span>
          {{index}}
          <v-icon style="color:white;float:right;">{{indicator.show ? 'fa fa-caret-up':'fa fa-caret-down'}}</v-icon>
        </span>
      </div>
      <div v-show="indicator.show" class="indicator-text">
        <span v-for="(name,count) in indicator.children" :key="count">
          {{name}}
        </span>
      </div>
    </div>
  </div>

  <div class="row" style="padding:15px;">
    <div class="col-md-12 cnick">
      <h1>Available Data</h1>
      <span class="about_content">
        Below is the total available data on this platform, all the indicators and their data sources with the available years
        <!-- <em style="cursor:pointer" @click="showAvailableSourceTable=!showAvailableSourceTable">{{showAvailableSourceTable? 'Hide table': 'Show table'}}</em> -->
      </span>
    </div>
  </div>

  <div v-show="showAvailableSourceTable" class="row" style="padding:15px;">
    <div class="col-xs-12 col-md-12">
      <div class="table-div">

  <table class="Table" cellspacing="0" cellpadding="0" v-bind:class="{'TableDefault': true, 'TableNormal': wrapperClick}">
    <thead>
        <tr>
            <th v-for="(col,index) in dataSourceForTable" :key="index">{{col}}</th>
        </tr>
    </thead>
    <tbody>
        <tr v-for="(data,index) in availableSourceData" :key="index">
            <td>{{data.number}}</td>
            <td>{{data.indicator}}</td>
            <!-- <td></td> -->
            <td v-for="(icon,i) in isDataForSourceAvailable[data.indicator]" :key="i">
              <div @click="showModal([data.indicator,i])" v-show="icon" v-tooltip.top="'Click to see available years'" style="cursor:default;height:20px;margin: 30px auto;width:50%;padding-right:60px;">
                <v-icon dark color="green" v-show="icon">check_circle</v-icon>
              </div>
            </td>
        </tr>
    </tbody>
</table>
</div>
      </div>

      <div class="col-xs-12 col-md-4 col-md-offset-5 col-xs-offset-4" style="padding-top:20px;padding-bottom:80px; color:white">
        <button class="btn" @click="wrapperClicked" style="background-color:#007D53; color:white; box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.4); border-color: #007D53;">{{wrapperClick? 'Show More': 'Show Less'}}</button>
      </div>
    </div>

    <div class="row" >
      <div class="col-md-12 cnick">
        <div class="">
          <h1>Data sources</h1>
        <span style="font-size:0.8rem;">
          The list of Data sources available on the Platform can be found below:
          <!-- <em style="cursor:pointer" @click="showTable=!showTable">{{showTable? 'Hide table': 'Show table'}}</em> -->
        </span>
        </div>
      </div>
      
    </div>
    <br>
    <div class="row">
        <div class="col-xs-12 col-md-4 cnick">
          <h1 >Routine</h1>
        </div>
    </div>
    <div class="row">
      <div class="">
        
        <div v-for="(data,index) in filterSourceRoutine(metaData)" :key=index  class="col-xs-12 col-md-4" style="padding-bottom:32px;">
        
        <div @click="data.show=!data.show" class="indicator-names-button">
          <span>
            {{data.source}}
            <v-icon style="color:white;float:right;">{{data.show ? 'fa fa-caret-up':'fa fa-caret-down'}}</v-icon>
          </span>
      </div>
      <div class="indicator-text" v-show="data.show">
          <span>
            <p>{{data.description}} <a href="javascript:;" @click="viewSourceMetadata(data.source)">Show more</a></p>
          </span>
        </div>
      </div>
      </div>
    </div>
    <br>
    <div class="row">
      
        <div class="col-xs-12 col-md-4 cnick">
          <h1 >Survey</h1>
        </div>
    </div>
    <div class="row">
      <div class="">
        
        
        <div v-for="(data,index) in filterSourceSurvey(metaData)" :key=index  class="col-xs-12 col-md-4" style="padding-bottom:32px;">
        
        <div @click="data.show=!data.show" class="indicator-names-button">
          <span >
            {{data.source}}
            <v-icon style="color:white;float:right;">{{data.show ? 'fa fa-caret-up':'fa fa-caret-down'}}</v-icon>
          </span>
      </div>
      <div class="indicator-text" v-show="data.show">
          <span>
            <p>{{data.description}} <a href="javascript:;" @click="viewSourceMetadata(data.source)">Show more </a></p>
          </span>
        </div>
        
      </div>
      </div>
    </div>
    <br>
    <div class="row">
        <div class="col-xs-12 col-md-4 cnick">
           <h1>Estimate</h1>
        </div>
    </div>
    <div class="row">
      <div v-for="(data,index) in filterSourceEstimate(metaData)" :key=index  class="col-xs-12 col-md-4" style="padding-bottom:32px;">
        <!-- col-md-12--col-md-3 -->
        <div @click="data.show=!data.show" class="indicator-names-button">
          <span >
            {{data.source}}
            <v-icon style="color:white;float:right;">{{data.show ? 'fa fa-caret-up':'fa fa-caret-down'}}</v-icon>
          </span>
      </div>
      <div class="indicator-text" v-show="data.show">
          <span>
            <p>{{data.description}} <a href="javascript:;" @click="viewSourceMetadata(data.source)">Show more</a></p>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-4 col-md-offset-9 col-xs-offset-3">
        <div id="bottom_of_page" class="">
      <router-link to="/central_analytics"><button class="btn" style="background-color:#007D53; color:white; box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.4); border-color: #007D53;"><i class="fa fa-angle-left"></i> Back to platform </button></router-link>
      </div>
    </div>
    <!--<button class="material-button-raised goto-top-of-page" id="scrollToTopButton" v-tooltip.left="'Go to top of page'" @click="scrollPage('#top_of_page')"><v-icon dark large color="white">keyboard_arrow_up</v-icon></button>
    <button class="material-button-raised goto-top-of-page" id="scrollToButtomButton" v-tooltip.left="'Go to bottom of page'" @click="scrollPage('#bottom_of_page')"><v-icon dark large color="white">keyboard_arrow_down</v-icon></button> -->
    </div>
    <br>
    <br>
    <b-modal :active.sync="showModalBoolean" has-modal-card>
      <form action="">
          <div class="modal-card modal-card1">
              <header class="modal-card-head">
                  <p class="modal-title-text">The <b>{{indicator}}</b> indicator is available on <b>{{source}}</b> for these years:</p>
                  <span @click="showModalBoolean=false" class="close-year-modal is-danger pull-right"><v-icon>close</v-icon></span>
              </header>
              <section class="modal-card-body year-body">
                <div>
                  <p v-for="(year, count) in yearsForSource" :key="count">
                    {{year}},
                  </p>
                </div>
              </section>
              <!-- <footer class="modal-card-foot">
                  <button class="button is-danger pull-right" @click="showModalBoolean=false" type="button">CLOSE</button>
              </footer> -->
          </div>
        </form>
      </b-modal>

    <div v-if="isSourceMetaModalActive"> 
      <table-modal :src="datasingle" :sourceMetaData="datafull" @switchOff="clearModal"></table-modal>
    </div>
  </div> 
  </div>
 
</template>

<script>
import TableModal from '../components/mt.vue';
export default {
  components: {
    TableModal
  },
  data(){
    return {
      datafull: [],
      datasingle: '',
      isSourceMetaModalActive: false,
      wrapperClick: true,
      aboutContent:true,
      isShowing:false,
      indicators: [],
      showIndicatorBool: [],
      apiUrl: "https://car-dashboard-others.firebaseio.com/masterSheet.json",
      // dataSourceUrl: "https://car-dashboard-others.firebaseio.com/data-source-meta-data.json",
      dataSourceUrl: "https://car-dashboard-others.firebaseio.com/data-source-meta-data-test.json",
      lsMetaData: JSON.parse(this.$ls.get('source_meta_dataset')),
      indicatorMetaData: JSON.parse(this.$ls.get('meta_data_dataset')),
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      // dataSources: ['NHMIS', 'MICS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
      dataSources: ['NHMIS', 'NDHS', 'NHSPSS', 'MICS', 'NNHS', 'NHA', 'NMIS', 'NARHS', 'PCCS', 'WHO-GHO', 'World Bank', 'IHME', 'WUENIC', 'UNAIDS', 'KDGHS'],
      dataSourceForTable: ['S/N','Sources/Indicators','NHMIS', 'NDHS', 'NHSPSS', 'MICS', 'NNHS', 'NHA', 'NMIS', 'NARHS', 'PCCS', 'WHO - GHO', 'World Bank', 'IHME', 'WUENIC', 'UNAIDS', 'KDGHS'],
      metaData: [],
      availableSourceData:[],
      isDataForSourceAvailable: {},
      showTable: true,
      showModalBoolean: false,
      showModalBoolean2:false,
      showAvailableSourceTable: true,
      indicatorNames: [],
      indicator: '',
      source: '',
      isDataLoadedFirstTime: false,
      yearsForSource: [],
      isLoading: false,
      modalContent:[],
      linksData:[],
      firstLink:[],
      linkFirst:''
    }
  },
  methods: {
    clearModal() {
      this.isSourceMetaModalActive = false;
    },
     viewSourceMetadata(theSource) {
      this.datasingle = theSource;
      this.datafull = this.lsMetaData;
      //console.log(this.datafull);
       this.isSourceMetaModalActive = true;

    },
    wrapperClicked (){
      this.wrapperClick = !this.wrapperClick;
    },
      /**
       * 
     
     processText(inputText) {
        var output = [];
        var json = inputText.split(',');
        json.forEach(function (item) {
            output.push(item.replace(/\'/g).split(' ').filter(Boolean));
        });
        return output;
    },

    showContents (){
      this.aboutContent = !this.aboutContent;
    },
      */
    navigateToCentralAnalytics() {
      this.isLoading = true;
      setTimeout(() => {
        this.$router.push('central_analytics');
      }, 1000);
    },
        /**
    changeShowIndicatorBool(val){
      this.showIndicatorBool[val] = !this.showIndicatorBool[val];
      // console.log(this.showIndicatorBool[val])
    },
 
    handleScroll(){
      // if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
      //   document.getElementById("scrollToTopButton").style.display = "block";
      //   document.getElementById("scrollToButtomButton").style.display = "none";
      // }
      // else {
      //   document.getElementById("scrollToTopButton").style.display = "none";
      //   document.getElementById("scrollToButtomButton").style.display = "block";
      // }
    },
    scrollPage(section_id){
      this.$scrollTo(section_id, 1000, {})
    },  */
    checkForAvailableData(){
      let dataObj = {};
      this.availableSourceData.map((obj,i) => {
        dataObj[obj.indicator] = [];
        this.dataSources.map((source,index) => {
          if(obj.dataSources.indexOf(source) > -1){
            dataObj[obj.indicator].push(true);
          } else {
            dataObj[obj.indicator].push(false);
          }
        });
      });
      this.isDataForSourceAvailable = dataObj;
      // console.log(this.isDataForSourceAvaliable);
    },
    showModal(message){
      this.indicator = message[0];
      this.source = this.dataSources[message[1]];
      this.yearsForSource = this.getAvailableYearBySource(message[0],this.dataSources[message[1]],this.lsData).split(',');
      this.showModalBoolean = true;
    },
    
    computeDataSourceMetaData(data){
      let tempData = [];
      let counter = 1;
      data.slice(1).map((elem,index) => {
        let dataObj = {
          number: counter,
          source: elem[0],
          fullName: elem[1],
          description: elem[2],
          link: elem[5],
          available: elem[3],
          next: elem[4],
          method: elem[6],
          subNationalData: elem[7],
          classification: elem[8],
          show: false

        };
        tempData.push(dataObj);
        counter++;
      });            
      this.metaData = tempData;
    },
    showContent(data){
       this.modalContent['source'] = data.source;
       this.modalContent['fullName'] = data.fullName;
       this.modalContent['description'] = data.description;
       this.modalContent['available'] = data.available;
       this.modalContent['next'] = data.next;
       this.modalContent['method'] = data.method;
       this.modalContent['subNatVal'] = data.subNationalData;
       this.modalContent['link'] = data.link;
       var check1 = data.link;
      
      // var hdsda = "http://mics.unicef.org/surveys, 1995 https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/Nigeria-1995-MICS_English.pdf, 1999 https://mapping.fmohconnect.gov.ng/index.php?gf-download=2019%2F05%2FMICS-99-Final-Report-Oct-2001-Nov-2002.pdf&form-id=4&field-id=69&hash=aad5fab711b3b635218d6477bc396a7607f432f4915a91378a09bed9318d2eec, 2007 https://mapping.fmohconnect.gov.ng/index.php?gf-download=2019%2F05%2FMICS-2007.pdf&form-id=4&field-id=69&hash=30fde9467a0badf677357516988b1112c3a8dbe5b8ecf1add3c0c87fa10f6d58, 2011 https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/MICS-2011.pdf, 2016 https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/MICS-2016-2017.pdf";
 
      // console.log(check1);

      // this.firstLink= [
      //   {
      //     year: 2102,
      //     link: "http://mics.unicef.org/surveys"
      //   },
      //   {
      //     year: 1995,
      //     link: "https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/Nigeria-1995-MICS_English.pdf"
      //   },
      //   {
          
      //     link: "https://mapping.fmohconnect.gov.ng/index.php?gf-download=2019%2F05%2FMICS-99-Final-Report-Oct-2001-Nov-2002.pdf&form-id=4&field-id=69&hash=aad5fab711b3b635218d6477bc396a7607f432f4915a91378a09bed9318d2eec"
      //   },
      // ]

      // var check2 = this.processText(hdsda);
      var check2 = check1.split(',');
      // console.log(check2);

      // var check3 = check2.split(' ');
      this.firstLink = check2;
      this.linkFirst = this.firstLink[0];

      // console.log(this.firstLink);
    //  var countedCheck2 = check2.length;

    //   for(var i = 0; i <= countedCheck2; i++){
    //     if(isNaN(check2)){
    //       this.firstLink.link[i].push(check2);
    //       // console.log("Numbers" + check2[i])
    //     }
    //     else{
    //       console.log("Strings" + check2[i])
    //     }
    //   }
    //  this.firstLink = check2
      // console.log(test[0]);
       this.showModalBoolean2 = true;
    },
    filterSourceSurvey(data){
      return data.filter(function(data){
        return data.classification == 'Survey';
      })
    },
    filterSourceRoutine(data){
      return data.filter(function(data){
        return data.classification == 'Routine';
      })
    },
    filterSourceEstimate(data){
      return data.filter(function(data){
        
        return data.classification == 'Estimate';
      })
    },
    computeAvailableSourceData(data){
      let counter = 1;
      this.availableSourceData = [];
      let indicatorNamesArray = data[0];
      // console.log(data)
      this.indicatorNames.map((indicator) => {
        let dataSourceArray = [];
        this.dataSources.map((dataSource) => {
          let indicatorSource = indicator.name + ' -> ' + dataSource;
          let indexOfIndicatorSource = indicatorNamesArray.indexOf(indicatorSource);
          if(indexOfIndicatorSource > 0){
            if(dataSourceArray.indexOf(dataSource) < 0){
              dataSourceArray.push(dataSource)
            }
          }
        });
        let obj = {
          number:counter,
          indicator: indicator.name,
          programArea: indicator.programArea,
          dataSources: dataSourceArray,
          availableYears: this.getAvailableYearBySource(indicator.name,dataSourceArray,data)
        }
        this.availableSourceData.push(obj);
        counter ++;
      });
      // console.log(this.availableSourceData)
    },
    getAvailableYearBySource(indicator,sources,data){
      let yearArray = [];
      if(Array.isArray(sources)){
        sources.map((source) => {
          let tempArray = [];
          let indicatorSource = indicator + ' -> ' + source;
          let indexOfIndicatorSource = data[0].indexOf(indicatorSource);
          data.slice(1).map((elem) => {
            if(elem[indexOfIndicatorSource] !== ""){
              if(tempArray.indexOf(elem[0]) < 0){
                tempArray.push(elem[0]);
              }
            }
          });
          yearArray.push({name:source, years:tempArray})
        });
      } else {
        let tempArray = [];
        let indicatorSource = indicator + ' -> ' + sources;
        let indexOfIndicatorSource = data[0].indexOf(indicatorSource);
        data.slice(1).map((elem) => {
          if(elem[indexOfIndicatorSource] !== ""){
            if(tempArray.indexOf(elem[0]) < 0){
              tempArray.push(elem[0]);
            }
          }
        });
        yearArray = tempArray.toString();
      }

      return yearArray;
    },
    getCarData() {
      return this.axios.get(this.apiUrl);
    },
    getMetaData() {
      return this.axios.get(this.dataSourceUrl)
    },
  },
  created(){
    /**
     * 
   
    this.axios.all([ this.getCarData(),this.getMetaData()])
      .then(this.axios.spread( (carData,metaData) => {
        // All requests are now complete
        // car data here ...
        this.lsData = carData.data;
        this.$ls.set('car_other_dataset', JSON.stringify(this.lsData));
        // console.log(this.lsData)
        this.isDataLoadedFirstTime = true;
        //meta data here ...
        this.lsMetaData = metaData.data;
        // console.log(metaData.data)
        this.$ls.set('source_meta_dataset',JSON.stringify(this.lsMetaData));
        this.isDataLoadedFirstTime = true;
      })
      ).catch(error => {
        if(!this.lsData){
          this.lsData = JSON.parse(this.$ls.get('car_other_dataset'));
        }
        if(!this.lsMetaData){
          this.lsMetaData = JSON.parse(this.$ls.get('source_meta_dataset'));
        }
        this.isDataLoadedFirstTime = true;
      })
  */
    let indicatorArray = {};
    let indicator = Object.assign({},this.$store.state.CAR.programAreasToIndicators);
    
    for(var i in indicator){
      indicatorArray[i] = {};
      indicatorArray[i].show = false;
      indicatorArray[i].children = indicator[i];
    }
    
    this.indicators = indicatorArray;
    // window.addEventListener('scroll', this.handleScroll);
  },
  /** 
  updated() {
    // let header = document.getElementsByClassName('stickyHeader');
    // let thead = document.getElementById('tableHead');
    // let icon = document.getElementById('back_to_car')
    // let iconTop = icon.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    // let cpanelNavTop = thead.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    // window.addEventListener('scroll', function() {
    //   if(document.documentElement.scrollTop > iconTop){
    //     icon.style.position = 'sticky';
    //     icon.style.top = '10px';
    //     icon.style.left = '10px';
    //   } else {
    //     if(document.body.getBoundingClientRect().top < 0){
              
    //     } else {
    //       icon.style.position = 'absolute';
    //       icon.style.top = '80px';
    //       icon.style.left = '100px';
    //     }
    //   }
    //   for(var i in header){
    //     if(document.documentElement.scrollTop > cpanelNavTop) {
    //       if(header[i].innerHTML){
    //         header[i].style.position = 'sticky';
    //         header[i].style.top = '0px';
    //         header[i].style.background = '#c4c4c4';
    //       }
    //       // cpanelNav.style.zindex = 0;
    //     } else {
    //       if(header[i].innerHTML){
    //         header[i].style.background = ''
    //       }
    //     }
    //   }
    // });
  },
  */
  mounted(){
    this.lsMetaData = JSON.parse(this.$ls.get('source_meta_dataset'));

    // this.isLoading = true;
    // console.log(this.lsData);
    if(this.lsMetaData){
      
      this.computeDataSourceMetaData(this.lsMetaData);
      this.isDataLoadedFirstTime = true;
    }

    //Dynamically populate program area array from sheet
        let indicatorsAndProgramAreas = {};
        this.$store.dispatch('indicatorLength', this.indicatorMetaData.length-1);     
        this.$store.dispatch('lastUpdated', this.indicatorMetaData[0][16]);     
        
        this.indicatorMetaData.slice(1).map((meta,count) => {
          
          let slope = [];
          let percent = "";

          if(meta[6] in indicatorsAndProgramAreas){
            indicatorsAndProgramAreas[meta[6]].push(meta[0])
          }
          else{
            indicatorsAndProgramAreas[meta[6]] = []
            indicatorsAndProgramAreas[meta[6]].push(meta[0])
          }

        });        
 
        this.$store.dispatch('indicatorsAndProgramAreas', indicatorsAndProgramAreas);          

    let indicatorArray = {};
    let indicator = Object.assign({},this.$store.state.CAR.programAreasToIndicators);
    for(var i in indicator){
      indicatorArray[i] = {};
      indicatorArray[i].show = false;
      indicatorArray[i].children = indicator[i];
      indicator[i].forEach((elem) => {
        let obj = {
          name: elem,
          programArea: i
        }
        this.indicatorNames.push(obj);
      });
    }
    if(this.lsData){
      this.computeAvailableSourceData(this.lsData);
      this.isDataLoadedFirstTime = true;
    }
    this.indicators = indicatorArray;
    this.checkForAvailableData();
  },
  watch: {
    showIndicatorBool(val){
    },
    lsMetaData(val){
      if(val){
        this.isDataLoadedFirstTime = true;
        this.computeDataSourceMetaData(val);
      }
    },
    lsData(val){
      if(val){
        this.isDataLoadedFirstTime = true;
        this.computeAvailableSourceData(val);
      }
    }
  }
}
</script>

<style scoped>


html {
  font-family:arial;
}

::-webkit-scrollbar {
    width: 10px;
    height: 12px;
    
}

::-webkit-scrollbar-thumb {
    background-color:darkgray;
}
 
table {
  border-collapse:none !important;
 }


.content table td, .content table th {
    border: none !important; 
    border-width: 0 0 1px;
    padding: 0.5em 0.75em;
    vertical-align: top;
}
.table-div {
  max-width:100%;
  overflow-x:auto;
  
  background-color:lightgray;
}

.Table {
  background-color:transparent;
  min-width:100%;
}

.Table thead,
.Table tbody {
  display:block;
}

.Table thead {
  background-color: #fcfcfc;
  border-bottom:1px solid whitesmoke;
  padding: 10px;
}

.Table thead th {
  background-color: #fcfcfc;
  font-size: 70%;
  font-weight: 400 !important;
  padding-right: 50px;
  padding-bottom: 50px;

}

.Table thead > tr {
  width:calc(100% - 10px);
  
}
.TableDefault tbody{
  max-height:100% !important;
}
.TableNormal tbody{
  max-height: 750px !important;
}
.Table tbody {
  
  overflow-x:hidden;
  font-size: 70%;
  font-weight: 400 !important;
  
 }
 
 .Table tr {
   display:flex;
 }
 
.Table td, 
.Table th {
  overflow:hidden;
  text-overflow:clip;
  white-space:initial;
  padding:3px 10px;
  width:100%;
  background-color:white;
}

.Table th {
  background-color:lightgray;
}

.Table tr:nth-child(1n) > td {
  background-color:#fcfcfc;
}

.Table tr:nth-child(2n) > td {
  background-color:#f2f2f2;
}

.Table th:nth-child(2),
.Table td:nth-child(2) {
  min-width:15%;
}

.nanleContainer {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  
}
#loading-screen {
  top: -158px !important;
}

@media (min-width: 768px) {
  .nanleContainer {
    width: 750px !important;
  }
}
@media (min-width: 992px) {
  .nanleContainer {
    width: 970px !important;
  }
}
@media (min-width: 1200px) {
  .nanleContainer {
    width: 1170px !important;
  }
}

@media screen and (max-width: 700px) {
  .TableNormal tbody{
    max-height: 450px !important;
  }
}
</style>



// WEBPACK FOOTER //
// about.vue?0678a17b